angular.module('qkr.inventory')
        .value('customErrors', {});


// WEBPACK FOOTER //
// ./src/inventory/value/inventory.customError.value.js